module.exports = __webpack_public_path__ + "img/arena_icon.8fc444c7.svg";